/* eslint-disable @typescript-eslint/member-delimiter-style */
import { logEvent, setUserProperties } from 'firebase/analytics'
import { getOrdernumber } from '../cookies'
import { whiteList } from '@/config/interceptor'

/**
 * 设置 firebase 用户属性
 * @description 收集用户的 ua 和 订单号信息
 */
export const setFirebaseUser = (options: { ordernumber: string }) => {
  if (!window.analytics) return
  setUserProperties(window.analytics, { ua: navigator.userAgent, ordernumber: options.ordernumber })
}

export enum EventName {
  /**
   * 无 API 请求
   */
  NOT_REQUST_API = 'custom_not_request_api',
  /**
   * API 请求错误
   */
  API_ERROR = 'custom_api_error',
}

/**
 * 添加自定义日志事件
 */
export const addLogEvent = (options: { eventName: EventName; msg?: string }) => {
  if (!window.analytics) return
  const { eventName, msg } = options
  logEvent(window.analytics, eventName, { msg })
}

export const logNotRequestApi = () => {
  setTimeout(() => {
    if (!whiteList.includes(window.location.pathname)) {
      if (!window.hasApiRequest) {
        addLogEvent({
          eventName: EventName.NOT_REQUST_API,
          msg: '5s 内未请求任何接口，用户可能访问受限',
        })
      } else {
        console.log('window.hasApiRequest', window.hasApiRequest)
      }
    }
  }, 5 * 1000)
}

export const logApiError = (msg: string) => {
  addLogEvent({ eventName: EventName.API_ERROR, msg: `ordernumber:${getOrdernumber()} ${msg}` })
}
